import { useState } from "react";
import { IconButton, Tooltip, Typography } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import type { StreamOutputStatsSnapshot } from "../utils/streamOutputs";
import { rtspViewerURL } from "../rtspTarget.mjs";

export default function RTSPLinks({ stats, fallback }: { stats?: StreamOutputStatsSnapshot; fallback: string }) {
  const [feedback, setFeedback] = useState("");
  const url = rtspViewerURL(stats?.playbackUrl, window.location.hostname);
  const copy = async () => {
    try {
      if (navigator.clipboard?.writeText) await navigator.clipboard.writeText(url);
      else {
        const field = document.createElement("textarea");
        field.value = url; field.style.position = "fixed"; field.style.opacity = "0";
        document.body.appendChild(field); field.select();
        const copied = document.execCommand("copy"); field.remove();
        if (!copied) throw new Error("Copy failed");
      }
      setFeedback("Copied");
    } catch { setFeedback("Could not copy; select the URL to copy it"); }
  };
  return <>
    <Typography component="span" variant="caption" sx={{ wordBreak: "break-all" }}>{url || fallback} · {stats?.publicationState || "stopped"}{stats?.publicationState === "serving" ? ` · ${stats.clientCount || 0} clients` : ""}</Typography>
    {url && <Tooltip title="Copy RTSP URL"><IconButton size="small" aria-label="Copy RTSP URL" onClick={e => { e.stopPropagation(); void copy(); }}><ContentCopyIcon fontSize="inherit" /></IconButton></Tooltip>}
    {feedback && <Typography component="span" variant="caption" role="status">{feedback}</Typography>}
    {stats?.lastError && <Typography component="span" variant="caption" color="error">{stats.lastError}</Typography>}
  </>;
}
